export default __webpack_public_path__ + "static/media/higher_primary_hi_ident_url_reversed_1.cafce51a.svg";